import initSearchResults from 'js/components/searchResults';

import "styles/pages/search-results.scss";

(function () {
  const el = document.querySelector('.search-results');
  if (!el) return;

  initSearchResults(el)
})()
